export var LOGIN_BUTTON_WRAPPER_ID = 'google-login-button-wrapper';
//# sourceMappingURL=constants.js.map